import { Grid } from '@material-ui/core';
import styled from 'styled-components';

export const Step3EditContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    // gap: 32px;
`;

export const Step3EditContentInputWrapper = styled.div`
    display: flex;
    gap: 8px;
    align-items: center;
`;



export const StyledCounter = styled(Grid)`
    margin-top: 4px;
    margin-bottom: 6px;
`;